<script>
import RadioCard from "./RadioCard.vue";

export default {
    name: "RadioCards",
    components: {RadioCard},

    props: {
        type: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true
        },
        eventBus: {}
    },

    data() {
        return {
            selectedOptionId: null
        }
    },

    methods: {
        handleInput(payload) {
            this.selectedOptionId = payload;
            this.$emit('input', payload);
        }
    },

    mounted() {
        this.eventBus.$on('reset', (payload) => {
            if (payload !== this.type) {
                return;
            }

            this.selectedOptionId = null;
        });
    }
}
</script>

<template>
    <div class="vue-radio-cards">
        <RadioCard
            v-for="option in options"
            :key="option.id"
            :option="option"
            :selected-option-id="selectedOptionId"
            @input="handleInput"
        />
    </div>
</template>
